import React, {ReactElement} from 'react';
import {Body, Headline} from '@lightricks/react-design-system';
import Features from '@contentlab/views/contentlab/pricing/components/pricing-bundle/Features';
import Price from '@contentlab/views/contentlab/pricing/components/pricing-bundle/PriceSection';
import {DEFAULT_CURRENCY} from '@contentlab/views/contentlab/pricing/constants';
import ContentLabPlanBundle from '@/types/models/pricing/contentLabPlanBundle';
import {SubscriptionPlan} from '@/types/models/pricing/subscriptionPlan';
import styles from './PricingBundle.module.scss';

export type PricingBundleProps = {
  plan: SubscriptionPlan | null;
  bundle: ContentLabPlanBundle;
  name: string;
  description: string;
  isActiveBundle: boolean;
  priceFootnote: string;
  button: ReactElement;
};

function PricingBundle({
  plan,
  bundle,
  name,
  description,
  isActiveBundle,
  priceFootnote,
  button,
}: PricingBundleProps) {
  return (
    <div className={styles.container}>
      <div
        className={`${styles.stickyBanner} ${
          isActiveBundle ? styles.activeBundle : ''
        }`}
      />
      <div
        className={`${styles.pricingBundle} ${
          isActiveBundle ? styles.activeBundle : ''
        }`}
      >
        <div className={styles.bundleHeader}>
          <Headline size="lg">{name}</Headline>
          <Body size="sm" className={styles.description}>
            {description}
          </Body>
        </div>
        <div className={styles.priceSection}>
          <Price
            bundle={bundle}
            currency={plan?.currency || DEFAULT_CURRENCY}
            price={plan?.price}
            originalPrice={undefined}
          />
          <Body size="md" className={styles.priceFootnoteText}>
            {priceFootnote}
          </Body>
        </div>
        <div className={styles.buttons}>{button}</div>
        <Features
          bundle={bundle}
          seatsCount={plan?.editors}
          videosCount={plan?.videos}
        />
      </div>
    </div>
  );
}

export default PricingBundle;
